/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { Theme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import React from "react";
import { useSelector } from 'react-redux';
import { useLocation } from "react-router";
import { canViewEvalType } from '../../App';
import NavLink from "../components/NavLink";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      position: "absolute",
      bottom: 0,
      marginLeft: "86px",
      height: "40px",
      display: "flex"
    },
    drawer: {
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(4, 0, 0)
    },
    link: {
      margin: theme.spacing(0,2)
    },
  })
);

interface NavLinksProps {
  orientation: "header" | "drawer";
}

const NavLinks = (props: NavLinksProps) => {
  const classes = useStyles({});
  const location = useLocation();
  const canViewWmps = useSelector(canViewEvalType('wmp_audit'));
  return (
    <div
      className={
        props.orientation === "header" ? classes.header : classes.drawer
      }
    >
      <NavLink
        path="/home"
        isActive={location.pathname === "/home"}
        orientation={props.orientation}
        >
        Home
      </NavLink>
      <NavLink
        path="/evals"
        isActive={location.pathname.startsWith("/evals")}
        orientation={props.orientation}
      >
        Evaluations
      </NavLink>
      <NavLink
        path="/follow-ups"
        isActive={location.pathname.startsWith("/follow-ups")}
        orientation={props.orientation}
      >
        Follow-Ups
      </NavLink>
      {
        canViewWmps ?
          <NavLink
            path="/wmps"
            isActive={location.pathname.startsWith("/wmps")}
            orientation={props.orientation}
          >
            ACCs
          </NavLink> : null
      }
    </div>
  );
};

export default NavLinks;
